//import './antAlert.less'

import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { GetRef, Tree, TreeProps } from 'antd';
import { DataNode } from 'antd/lib/tree';

export interface AntTreeDataNode extends Omit<DataNode, 'children'> {
	children?: AntTreeDataNode[];
}

export type AntTreeRef = GetRef<typeof Tree>;

interface AntTreeProps<T extends AntTreeDataNode = AntTreeDataNode> extends TreeProps<T> {
	componentRef: React.Ref<AntTreeRef>;
}

const b = require('b_').with('ant-tree-wrapper');

export const AntTree = observer((props: AntTreeProps) => {
	const { className, ...antNativeProps } = props;

	const classes = classnames(b(), className);

	return <Tree ref={props.componentRef} className={classes} {...antNativeProps} />;
});
